import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { OrderProductKeyAttributeSnapshot } from './OrderProductKeyAttributeSnapshot'
import { EntityRefOfString } from './EntityRefOfString'
import { OrderItemInstanceShorDto } from './OrderItemInstanceShorDto'
/**
* Class OrderItemListDto
*  
*/
export class OrderItemListDto extends ActiveModel {

  /**
  * productId
  * Идентификатор продукта<br>  */
  @ActiveField(0)
  productId: number = 0


/**
  * name
  * Название продукта
  */
  @ActiveField('')
  name: string = ''


  /**
  * price
  * Стоимость единицы  */
  @ActiveField(0)
  price: number = 0


/**
  * article
  * Артикул товара
  */
  @ActiveField('')
  article: string = ''


/**
  * @property keyAttributes
  * Слепок ключевых атрибутов<br>  */
  @ActiveField({
    factory: [OrderProductKeyAttributeSnapshot, () => []]
  })
  keyAttributes: Array<OrderProductKeyAttributeSnapshot> = []


  /**
  * inStock
  * Кол-во товара на складах<br>  */
  @ActiveField()
  inStock?: number


/**
  * @property imagesIds
  * Идентификаторы изображений<br>  */
  @ActiveField({
    factory: [EntityRefOfString, () => undefined]
  })
  imagesIds?: Array<EntityRefOfString>


  /**
  * reviewId
  * Отзыв покупателя на карточку этого товара (RFC-008): для кнопки «Мой отзыв» вместо «Оценить»<br>  */
  @ActiveField()
  reviewId?: null | number


/**
  * @property instances
  * Информация об отдельных позициях продукта<br>  */
  @ActiveField({
    factory: [OrderItemInstanceShorDto, () => []]
  })
  instances: Array<OrderItemInstanceShorDto> = []
}
